import { render } from "./SliderTestIcon.vue?vue&type=template&id=524882f0"
import script from "./SliderTestIcon.vue?vue&type=script&lang=js"
export * from "./SliderTestIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__